import { css } from '@repo/pandacss/styled-system/css';
import { Skeleton } from '../../Skeleton';

export function CategorySectionTitleSkeleton() {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        columnGap: '2',
        rowGap: '2',
        marginBottom: '4',
      })}
    >
      <Skeleton variant="rounded" width={250} height={20} />
      <Skeleton variant="rounded" width="100%" height={30} />
    </div>
  );
}
